<script setup lang="ts">
import { computed, watch } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { useViewComposable } from '@/views/composable';
import { getTextVariant } from '@/utils/stringUtils';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Select from 'primevue/select';

interface Props {
  ruleAssignment: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:ruleAssignment': [value: any];
}>();

const ruleAssignmentPriority = computed({
  get() {
    return props.ruleAssignment;
  },
  set(value) {
    emits('update:ruleAssignment', value);
  }
});

const currentLanguage = getCurrentLocale();
const { departments } = useViewComposable();

const convertDataRuleOutcome = (data: any) => {
  return getTextVariant(currentLanguage, data.ruleOutcomeTitle, data.ruleOutcomeTitleFr);
};

watch(
  () => props.ruleAssignment,
  (newValue) => {
    newValue.forEach((rule: any) => {
      if (!rule.priority) {
        rule.priority = 0;
      }
    });
  },
  { deep: true }
);
</script>

<template>
  <div class="rule-assignment-priority">
    <div v-for="(rule, index) in ruleAssignmentPriority" :key="index">
      <div class="field grid">
        <div class="col-5">
          <p>{{ $t('rule_assignment.rule_outcome') }}</p>
          <div>
            <InputText :modelValue="convertDataRuleOutcome(rule)" disabled />
          </div>
        </div>
        <div class="col-3">
          <p>{{ $t('rule_assignment.priority') }}</p>
          <InputNumber :min="0" v-model="rule.priority" />
        </div>
        <div class="col-4">
          <p>{{ $t('rule_assignment.auto_assign') }} <span class="text-primary">*</span></p>
          <Select id="auto-assign-select" v-model="rule.autoAssign" :options="departments" optionLabel="label" optionValue="value">
            <template #value="slotProps">
              <span v-if="slotProps.value">{{ departments.find((department) => department.value === slotProps.value)?.label }}</span>
            </template>
          </Select>
        </div>
      </div>
    </div>
  </div>
</template>
